import { Component, Input, Output, OnChanges, EventEmitter, OnInit, SimpleChanges, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective, Validators } from "@angular/forms";
import { NgbTypeaheadConfig } from '@ng-bootstrap/ng-bootstrap';
import { GeoService } from 'src/app/services/geo.service';
import { MiscService } from 'src/app/services/misc/misc.service';
import { Observable, OperatorFunction, debounceTime, distinctUntilChanged, from, lastValueFrom, map, forkJoin, finalize, pairwise } from "rxjs";
import { mandatoryPincodeCountries, MobileNumberValidation, pincodePattern, PincodeValidation } from 'src/app/models/validator';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { CustomerService } from 'src/app/services/customer.service';
import { Utilities } from 'src/app/models/utilities';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NetworkService } from 'src/app/services/network.service';
@Component({
  selector: 'app-location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss']
})
export class LocationComponent implements OnChanges {

  @Input() isDefaultUserLocationSelected: boolean;
  @Input() selectedSCId: number;
  @Input() formGroupName: string;
  @Output() focusEmit = new EventEmitter<boolean>();
  @Input() formSubmitted: boolean = false;
  @Input() location: any;
  @Output() pincodeChild = new EventEmitter<void>();
  @Output() getLocation = new EventEmitter<any>();
  @Output() resetShipper = new EventEmitter<any>();
  @ViewChild('country') countryField!: NgSelectComponent;

  @Output() manualFieldChange = new EventEmitter<any>();
  locationDetailsForm: FormGroup;

  _location: any[] = [];
  countryList: any[] = [];
  stateList: any[] = [];
  cityList: any[] = [];
  pincodeList: any[] = [];
  resPincodeList: any[] = [];
  areaList = [];
  selectedLocation: any;
  countryCode: any;
  contractDataList = [];

  isCountryMandate = false;
  isStateMandate = false;
  isCityMandate = false;
  isAreaMandate = false;
  isAddressMandate = false;
  isMobileMandate = false;
  isAccessTypeCustomer = false;
  useEnterKey: any;

  minPincode: number;
  maxPincode: number;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private geoService: GeoService,
    private miscService: MiscService,
    private typeaheadConfig: NgbTypeaheadConfig,
    private ngxLoader: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    private customerService: CustomerService,
    public utilities: Utilities,
    private networkService: NetworkService
  ) {
    // typeaheadConfig.showHint = true;
  }

  async ngOnInit() {

    const ud: any = this.appCoreService.GetUserData();
    if (ud && ud.accessType == "Customer" && ud?.metaInfo?.customerid) {
      this.isAccessTypeCustomer = true;
      const customerId = ud?.metaInfo?.customerid;
      await this.getContractCustomer(customerId);

    }
    this.locationDetailsForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    this.loadDataFromAPI();

    this.locationDetailsForm.get('ddlCountry').valueChanges.pipe(pairwise()).subscribe(([previousValue, currentValue]) => {
      // console.log('ddlCountry', currentValue);

      if (currentValue && previousValue != currentValue) {
        // this.pincodeList = this.resPincodeList.filter(x => x.countryisocode === currentValue);
        this.bindPincodes(currentValue);
        this.setPincodeValidation();
      }
    });
    this.appCoreService.SelectedServiceCenter().subscribe(val => {
      if (val) {
        this.selectedSCId = val;
        // bind selected address data
        if (this.selectedSCId) {
          this.locationDetailsForm.reset();
          this.bindUserLocationOverSc();
        }
      }
    });
    // this.bindUserLocationOverSc();
  }

  async ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      const change = changes[propName];
      if (change.firstChange) {
        return; // Skip the first change after initialization
      }
    };

    this.locationDetailsForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;

    // changes.prop contains the old and the new value...
    if (changes['location'] && changes['location'].firstChange) return;
    this.setFieldValidations();
    if (changes['location'] && changes['location'].currentValue) {
      this.selectedLocation = changes['location'].currentValue;

      if (this.selectedLocation?.locationapply) {
        let country: any, state: any, city: any;
        const loc = this.selectedLocation.locationapply;
        country = this.countryList.filter((item) => item.code == loc.country)[0]?.isocode;

        this.bindStatesByCountry(country).then(() => {

          state = this.stateList.filter((item) => item.code == loc.state)[0]?.isocode;

          this.bindCitiesByState(state).then(() => {
            city = this.cityList.filter((item) => item.code == loc.city)[0]?.isocode;
            this.locationDetailsForm.patchValue({
              ddlCountry: country,
              ddlState: state,
              ddlCity: city
            })
          })
        });
      }

      let selectedLocArea = (typeof this.selectedLocation.area === 'string') ? { area: this.selectedLocation.area } : this.selectedLocation.area;
      let selectedLocPincode = (typeof this.selectedLocation.pincode === 'string') ? { pincode: this.selectedLocation.pincode } : this.selectedLocation.pincode;

      await this.bindStatesByCountry(this.selectedLocation.country);
      await this.bindCitiesByState(this.selectedLocation.state);

      this.locationDetailsForm.patchValue({
        ddlCountry: this.selectedLocation.country,
        ddlState: this.selectedLocation.state,
        ddlCity: this.selectedLocation.city,
        txtPincode: selectedLocPincode,
        txtAddress1: this.selectedLocation.address1,
        txtAddress2: this.selectedLocation.address2,
        txtArea: selectedLocArea,
        txtMobileNo: this.selectedLocation.mobileno,
        txtTelephoneNo: this.selectedLocation.tel,
      });
      // this.bindPincodes();
      // this.setPincodeValidation();

    }
    // console.log('this.rootFormGroup, locationDetailsForm', this.rootFormGroup, this.locationDetailsForm);
  }

  loadDataFromAPI() {
    try {
      forkJoin({
        countries: this.geoService.GetAllCountries(),
        areas: this.miscService.GetAllAreas(),
        // pincodes: this.geoService.GetAllPincodes()
      }).pipe(
        finalize(() => {
          //get pincode over default country
          // this.pincodeList = this.resPincodeList.filter(x => x.countryisocode === this.appCoreService.GetUserData()?.metaInfo.defaultcountry);
          this.setPincodeValidation();
          this.bindUserLocationOverSc();
        })
      ).subscribe((res) => {
        if (res) {
          if (res.countries.success && res.countries?.data?.length) {
            const metaInfo = this.appCoreService.GetUserData()?.metaInfo;
            const defaultCountryCode = metaInfo.defaultcountry;
            if (metaInfo.operationtype.includes('Domestic') && metaInfo.operationtype.includes('International')) {
              this.countryList = res.countries.data;
            } else if (metaInfo.operationtype.includes('Domestic')) {
              this.countryList = res.countries.data.filter(item => item.isocode === defaultCountryCode);
              this.locationDetailsForm.get('ddlCountry').setValue(defaultCountryCode);

              // if domestic call states
              // this.bindStatesByCountry(defaultCountryCode);

              this.locationDetailsForm.get('ddlCountry').disable();
            } else if (metaInfo.operationtype.includes('International')) {
              this.countryList = res.countries.data.filter(item => item.isocode !== defaultCountryCode);
            } else {
              this.countryList = res.countries.data;
            }

            if (this._location.length)
              this._location[0]["country"] = this.countryList;
            else
              this._location.push({ "country": this.countryList });

            this.getLocation.emit(this._location);
          }
          if (res.areas.success && res.areas?.data?.length) {
            this.areaList = res.areas?.data;
          }
          // if (res.pincodes.success && res.pincodes?.data?.length) {
          //   this.pincodeList = res.pincodes?.data;
          //   this.resPincodeList = res.pincodes?.data;
          // }
        }
      })
    } catch (error) {

    }
  }
  async getContractCustomer(customerId: any) {
    try {
      const res = await lastValueFrom(this.customerService.getContractDetailbyCustId(customerId));
      if (res && res.success) {
        const data = res.data;

        // Find all selected customers by ID
        let selectedCustomers: any[] = data.filter(customer => customer.customerid === customerId);

        let formattedData = [];

        if (selectedCustomers && selectedCustomers.length > 0) {
          formattedData = selectedCustomers.map(customer => ({
            ...customer,
            fromdate: this.utilities.formatDate(customer.fromdate).dateString,
            todate: this.utilities.formatDate(customer.todate).dateString
          }));

          const today = new Date();
          const formattday = this.utilities.formatDate(today).dateString

          const customerContracts = formattedData.filter(contract => {
            const fromDate = contract.fromdate;
            const toDate = contract.todate;
            return fromDate <= formattday && formattday <= toDate;
          });
          if (customerContracts && customerContracts.length > 0) {
            const id = customerContracts[0].id;
            this.getContractInfo(id);
          }
        } else {

        }
      }

    } catch (e) {
      console.error(e);
    }
  }

  onChangeTelephone() {
    const inputValue = this.locationDetailsForm.get('txtTelephoneNo')?.value;

    if (inputValue) {
      const formattedValue = inputValue
        .split(',')
        .map((part) => part.trim()) // Trim each part
        .filter((part) => part !== '') // Remove empty parts
        .join(', ');

      // Update the form control with the formatted value
      this.locationDetailsForm.get('txtTelephoneNo')?.setValue(formattedValue, { emitEvent: false });
    }
  }

  preventChars(event: any) {
    this.locationDetailsForm.get('txtTelephoneNo').setValue(event.target.value.replace(/[^0-9,]/g, ''))
  }

  async getContractInfo(id: any) {
    // console.log('id',id)
    this.customerService.getContractDetailById(id).subscribe((res) => {
      if (res && res.success) {
        this.contractDataList = res.data;

        // console.log('state', this.stateList)
        // console.log('city', this.cityList)

        const filteredStateOptions = this.stateList.filter(option =>
          this.contractDataList.some(contract => contract.originstate === option.name)
        );
        const filteredCityOptions = this.cityList.filter(option =>
          this.contractDataList.some(contract => contract.origincity === option.name)
        );
        const filteredCountryOptions = this.countryList.filter(option =>
          this.contractDataList.some(contract => contract.origincountry === option.name)
        );

        this.stateList = filteredStateOptions;
        this.cityList = filteredCityOptions;
        this.countryList = filteredCountryOptions;

      } else {

      }
    });
  }

  setPincodeValidation() {
    if (this.locationDetailsForm) {
      const pincodeControl = this.locationDetailsForm.get('txtPincode');
      const matchedCountryCode = this.countryList.find(x => x.isocode === this.countryCode)?.code;

      if (pincodeControl) {
        let validators = [];

        const isMandatory = matchedCountryCode && mandatoryPincodeCountries.includes(matchedCountryCode);

        // Add 'required' validator if the country requires it
        if (isMandatory) {
          validators.push(Validators.required);
        }

        // Apply pattern/length validation only if value is present (i.e., user entered something)
        if (typeof pincodeControl?.value === 'string') {
          if (matchedCountryCode && pincodePattern[matchedCountryCode]) {
            const pattern = pincodePattern[matchedCountryCode];

            this.minPincode = 0
            this.maxPincode = 0
            this.minPincode = this.utilities.getMinLength(pattern);
            this.maxPincode = this.utilities.getMaxLength(pattern);

            validators.push(
              Validators.pattern(pattern),
              Validators.minLength(this.minPincode),
              Validators.maxLength(this.maxPincode)
            );
          } else {
            // Fallback validator only when value exists
            pincodeControl.clearValidators();
          }
        }
        pincodeControl.setValidators(validators);
        pincodeControl.updateValueAndValidity();
      }
    }
  }


  async bindlocationByPincode(event: any) {
    try {
      this.locationDetailsForm?.get('txtPincode')?.clearValidators();
      this.locationDetailsForm.get('txtPincode').updateValueAndValidity();
      if (event) {
        // this.maxLength(1000);
        const pinObj = event.item;
        const foundPincode = this.pincodeList.filter((x: any) => pinObj.pincode == x.pincode);
        // this.ngxLoader.start();
        if (foundPincode?.length > 0) {
          this.locationDetailsForm.get('ddlCountry').setValue(pinObj.countryisocode);
          // Used from to convert promises to observables before lastValueFrom
          await lastValueFrom(from(this.bindStatesByCountry(pinObj.countryisocode)));
          await lastValueFrom(from(this.bindCitiesByState(pinObj.stateisocode)));
          this.locationDetailsForm.get('ddlState').setValue(pinObj.stateisocode);
          this.locationDetailsForm.get('ddlCity').setValue(pinObj.cityisocode);
        }
        // this.ngxLoader.stop();
        this.pincodeChild.emit();
      } else {
        this.setPincodeValidation();
      }
    } catch (error) {
      // this.ngxLoader.stop();
      console.error(error);
    }
  }


  setFieldValidation(controlName: string) {
    const control = this.locationDetailsForm.controls[controlName];
    const isMandate = control?.errors?.required ? true : false;
    if (isMandate) {
      switch (controlName) {
        case 'ddlCountry':
          this.isCountryMandate = isMandate;
          break;
        case 'ddlState':
          this.isStateMandate = isMandate;
          break;
        case 'ddlCity':
          this.isCityMandate = isMandate;
          break;
        case 'txtArea':
          this.isAreaMandate = isMandate;
          break;
        case 'txtAddress1':
          this.isAddressMandate = isMandate;
          break;
        case 'txtMobileNo':
          this.isMobileMandate = isMandate;
          break;
        default:
          this.isCountryMandate = false;
          this.isStateMandate = false;
          this.isCityMandate = false;
          this.isAreaMandate = false;
          this.isAddressMandate = false;
          this.isMobileMandate = false;
          break;
      }
      this.locationDetailsForm.get(controlName).setValidators([Validators.required]);
    } else {
      this.locationDetailsForm.get(controlName).clearValidators();
    }

    this.locationDetailsForm.get(controlName).updateValueAndValidity();
  }

  setFieldValidations() {
    this.setPincodeValidation();
    this.setFieldValidation('ddlCountry');
    this.setFieldValidation('ddlState');
    this.setFieldValidation('ddlCity');
    this.setFieldValidation('txtArea');
    this.setFieldValidation('txtAddress1');
    this.setFieldValidation('txtMobileNo');
    //set mobile validation - issue formControl validation parent-to-child
    this.locationDetailsForm.get('txtMobileNo').addValidators([MobileNumberValidation]);
    this.locationDetailsForm.get('txtMobileNo').updateValueAndValidity();
  }


  bindCountries() {
    try {
      this.geoService.GetAllCountries().subscribe((res) => {
        if (res && res.success) {
          const metaInfo = this.appCoreService.GetUserData()?.metaInfo;
          const defaultCountryCode = metaInfo.defaultcountry;
          if (metaInfo.operationtype.includes('Domestic') && metaInfo.operationtype.includes('International')) {
            this.countryList = res.data;
          } else if (metaInfo.operationtype.includes('Domestic')) {
            this.countryList = res.data.filter(item => item.isocode === defaultCountryCode);
            this.locationDetailsForm.get('ddlCountry').setValue(defaultCountryCode);
            this.locationDetailsForm.get('ddlCountry').disable();
            this.onCountryChange();
          } else if (metaInfo.operationtype.includes('International')) {
            this.countryList = res.data.filter(item => item.isocode !== defaultCountryCode);
          } else {
            this.countryList = res.data;
          }

          if (this._location.length)
            this._location[0]["country"] = this.countryList;
          else
            this._location.push({ "country": this.countryList });

          this.getLocation.emit(this._location);
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  onCountryChange() {
    const selectedValue = this.locationDetailsForm.get('ddlCountry').value;
    this.locationDetailsForm.get('ddlCountry').setValue(selectedValue);
    this.locationDetailsForm.get("txtPincode").reset();
    this.locationDetailsForm.get('ddlState').reset();
    this.locationDetailsForm.get('ddlCity').reset();
    this.stateList = [];
    this.cityList = [];
    if (selectedValue) {
      this.bindStatesByCountry(selectedValue);
      this.bindCitiesByCountry(selectedValue);
    };
    this.setPincodeValidation();
  }


  async bindStatesByCountry(countryCode?: string): Promise<void> {
    try {
      if (countryCode?.length) {

        const observable = this.geoService.GetAllStates({ countrycode: countryCode });
        const res = await lastValueFrom(observable);

        if (res && res.success) {
          this.stateList = res.data;
          this.countryCode = countryCode;

          //this._location.push({"state": this.stateList});

          if (this._location.length)
            this._location[0].state = this.stateList;
          else
            this._location.push({ "state": this.stateList });

          this.getLocation.emit(this._location);
        } else {
          throw new Error('Error fetching states');
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  onStateChange() {
    this.locationDetailsForm.get("txtPincode").reset();
    const selectedValue = this.locationDetailsForm.get('ddlState').value;
    this.locationDetailsForm.get('ddlCity').reset();
    this.cityList = [];
    if (selectedValue) {
      // console.log("IFSELECTEDVCALUE",selectedValue);
      this.bindCitiesByState(selectedValue);
    }
    else {
      const selectedValue = this.locationDetailsForm.get('ddlCountry').value;
      // console.log("IF- NOT - SELECTEDVCALUE",selectedValue);
      this.bindCitiesByCountry(selectedValue); 
    }
  }

  onCityChange() {
    this.locationDetailsForm.get("txtPincode").reset();
  }

  async bindCitiesByCountry(countryIsoCode?: string): Promise<void> {
    try {
      if (countryIsoCode?.length) {
        // console.log("BINDCITIESBYCOUNTRYISOCODE", countryIsoCode);
        const observable = this.geoService.GetAllCities({ countryisocode: countryIsoCode });
        const res = await lastValueFrom(observable);
        // console.log("RES---",res.data);
        if (res && res.success) {
          this.cityList = res.data;
          this.countryCode = countryIsoCode;

          // console.log("this.stateList--",this.cityList)
          //this._location.push({"state": this.stateList});

          if (this._location.length)
            this._location[0].state = this.cityList;
          else
            this._location.push({ "state": this.cityList });

          this.getLocation.emit(this._location);
        } else {
          throw new Error('Error fetching states');
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async bindCitiesByState(stateCode?: string): Promise<void> {
    try {
      if (stateCode?.length) {
        const observable = this.geoService.GetAllCities({ statecode: stateCode });
        const res = await lastValueFrom(observable);

        if (res && res.success) {
          this.cityList = res.data;

          //this._location.push({"city": this.cityList});
          if (this._location.length)
            this._location[0].city = this.cityList;
          else
            this._location.push({ "city": this.cityList });

          this.getLocation.emit(this._location);
        } else {
          throw new Error('Error fetching cities');
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  bindAreas() {
    try {
      this.miscService.GetAllAreas().subscribe((res) => {
        // console.log('areas', res);
        if (res && res.success) {
          this.areaList = res.data;
          // console.log(this.locationDetailsForm.get('txtArea').value);
        } else {
          // handle some error
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  bindPincodes(countryisocode) {
    try {
      this.geoService.GetAllPincodes({ countryisocode: countryisocode }).subscribe((res) => {
        if (res && res.success) {
          // console.log('pincode data', res);
          this.pincodeList = res.data;
          this.resPincodeList = res.data;
          // console.log(this.locationDetailsForm.get('txtArea').value);
        } else {
          // handle some error
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  searchArea: OperatorFunction<string, readonly { area; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.areaList.filter((v) => v.area.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  // search = (text$: Observable<string>) => {
  //   const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
  //   return merge(debouncedText$).pipe(
  //     map(term => (term === '' ? this.areaList
  //       : this.areaList.filter(v => v.area.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
  //   );
  // }

  areaFormatter = (x: { area: string }) => x.area;

  searchPincode: OperatorFunction<string, readonly { pincode; flag }[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term) =>
        term === ''
          ? []
          : this.pincodeList.filter((v) => v.pincode.toLowerCase().startsWith(term.toLowerCase())).slice(0, 10),
      ),
    );

  pincodeFormatter = (x: { pincode: string }) => x.pincode;

  focusFirstField() {
    this.utilities.focusFirstElement(this.locationDetailsForm)
  }

  bindUserLocationOverSc() {
    if (this.selectedSCId && this.isDefaultUserLocationSelected) {
      this.networkService.GetServiceCentersById(this.selectedSCId).subscribe((res) => {
        if (res && res.success) {
          let location = res?.data[0]?.location;
          if (location) {
            this.locationDetailsForm.get('ddlCountry').setValue(location.country);
            this.bindStatesByCountry(location.country).then(() => {
              this.locationDetailsForm.get('ddlState').setValue(location.state);
              this.bindCitiesByState(location.state).then(() => {
                this.locationDetailsForm.get('ddlCity').setValue(location.city);
              });
            });
            this.bindPincodes(location.country);
          }
        }
      })
    }
  }
};
